import { Json, JsonArray, JsonRecord } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import * as D from 'io-ts/Decoder';
import * as E from 'io-ts/Encoder';

const JSON_PRIMITIVE = D.nullable(D.union(
  D.number,
  D.string,
  D.boolean,
));

const JSON_ANY: D.Decoder<unknown, Json> = D.lazy('Json', () => D.union(
  JSON_PRIMITIVE,
  D.array(JSON_ANY),
  D.record(JSON_ANY),
));

export const JSON_VALUE: C.Codec<unknown, Json, Json> =
    C.make(JSON_ANY, E.id());

export const JSON_ARRAY: C.Codec<unknown, JsonArray, JsonArray> =
    C.make(D.readonly(D.array(JSON_ANY)), E.id());

export const JSON_RECORD: C.Codec<unknown, JsonRecord, JsonRecord> =
    C.make(D.record(JSON_ANY), E.id());
